import { Button } from "@devhop/ui";
import { HelpCircle, PlusIcon } from "lucide-react";

type ContractsToolbarProps = {
  canManage: boolean;
  onCreate: () => void;
  onStartTour?: () => void;
};

export function ContractsToolbar({
  canManage,
  onCreate,
  onStartTour,
}: ContractsToolbarProps) {
  return (
    <div className="mb-2 flex flex-col gap-4">
      <div className="flex flex-wrap items-center justify-between space-y-2">
        <div>
          <div className="mb-2 flex items-center gap-3">
            <h2 className="font-bold text-2xl tracking-tight">ສັນຍາ</h2>
            {onStartTour && (
              <Button
                variant="ghost"
                size="icon"
                className="size-7 rounded-full"
                onClick={onStartTour}
              >
                <HelpCircle className="size-5" />
              </Button>
            )}
          </div>
          <p className="text-muted-foreground">ຈັດການສັນຍາທັງໝົດ</p>
        </div>
        {canManage && (
          <div className="flex items-center space-x-2" data-tourid="contracts-toolbar">
            <Button onClick={onCreate}>
              <PlusIcon className="h-4 w-4" />
              ສ້າງສັນຍາ
            </Button>
          </div>
        )}
      </div>
    </div>
  );
}
